import Vue from 'vue'
import VueRouter from 'vue-router'

import LoginView from '../views/LoginView.vue'
import IndexView from '../views/Back/IndexView.vue'
import MainView from '../views/Back/MainView.vue'

import AdminListView from '../views/Back/Admin/AdminListView.vue'

import EnhanceModeListView from '../views/Back/EnhanceMode/EnhanceModeListView.vue'
import EnhancePackageListView from '../views/Back/EnhancePackage/EnhancePackageListView.vue'
import EnhanceResolutionListView from '../views/Back/EnhanceResolution/EnhanceResolutionListView.vue'

import GenerateModeListView from '../views/Back/GenerateMode/GenerateModeListView.vue'
import GeneratePackageListView from '../views/Back/GeneratePackage/GeneratePackageListView.vue'
import GenerateResolutionListView from '../views/Back/GenerateResolution/GenerateResolutionListView.vue'

import EnhanceListView from '../views/Back/Enhance/EnhanceListView.vue'

import UserListView from '../views/Back/User/UserListView.vue'
import UserCreditListView from '../views/Back/UserCredit/UserCreditListView.vue'

import ApiLogsListView from '../views/Back/ApiLogs/ApiLogsListView.vue'
import GenerationsListView from '../views/Back/Generations/GenerationsListView.vue'
import UserNotificationsListView from '../views/Back/UserNotifications/UserNotificationsListView.vue'

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

// 重写push方法
VueRouter.prototype.push = function(location) {
  return originalPush.call(this, location).catch(err => err);
};

// 重写replace方法
VueRouter.prototype.replace = function(location) {
  return originalReplace.call(this, location).catch(err => err);
};

Vue.use(VueRouter)

const routes = [
  {
    path: '/Login',
    name: 'LoginView',
    component: LoginView
  },
  {
    path: '/',
    name: 'IndexView',
    component: IndexView,
    children: [
      {
        path: '/Main',
        name: 'MainView',
        component: MainView
      },
      {
        path: '/Admin/List',
        name: 'AdminListView',
        component: AdminListView
      },
      {
        path: '/EnhanceMode/List',
        name: 'EnhanceModeListView',
        component: EnhanceModeListView
      },
      {
        path: '/EnhancePackage/List',
        name: 'EnhancePackageListView',
        component: EnhancePackageListView
      },
      {
        path: '/EnhanceResolution/List',
        name: 'EnhanceResolutionListView',
        component: EnhanceResolutionListView
      },
      {
        path: '/GenerateMode/List',
        name: 'GenerateModeListView',
        component: GenerateModeListView
      },
      {
        path: '/GeneratePackage/List',
        name: 'GeneratePackageListView',
        component: GeneratePackageListView
      },
      {
        path: '/GenerateResolution/List',
        name: 'GenerateResolutionListView',
        component: GenerateResolutionListView
      },
      {
        path: '/User/List',
        name: 'UserListView',
        component: UserListView
      },
      {
        path: '/UserCredit/List',
        name: 'UserCreditListView',
        component: UserCreditListView
      },
      {
        path: '/ApiLogs/List',
        name: 'ApiLogsListView',
        component: ApiLogsListView
      },
      {
        path: '/Generations/List',
        name: 'GenerationsListView',
        component: GenerationsListView
      },
      {
        path: '/UserNotifications/List',
        name: 'UserNotificationsListView',
        component: UserNotificationsListView
      },
      {
        path: '/Enhance/List',
        name: 'EnhanceListView',
        component: EnhanceListView
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
